import CalculatorModal from 'components/fx/CalculatorModal';
import { CURRENCY_FLAG_REFERENCES, CURRENCY_NAME_REFERENCE } from 'constants';
import { format } from 'helpers';
import useFxCalculator from 'hooks/fx/useFxCalculator';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import styled from 'styled-components';

const FXRateItem = ({ currency, rate, rateData }) => {
  const [isShowCalculatorModal, setShowCalculatorModal] = useState(false);
  const [orderEdit, setOrderEdit] = useState(null);

  const { handleRateItemOnShowCalculatorModal } = useFxCalculator();
  const { resetAddTransactionInformation } = useFxFormAddTransactionStore();

  const handleOnShowCalculatorModal = async () => {
    handleRateItemOnShowCalculatorModal({
      sellRate: rateData,
      callback: (order) => {
        setOrderEdit(order);
        setShowCalculatorModal(true);
        resetAddTransactionInformation();
      },
    });
  };
  const handleOnCloseCalculatorModal = () => {
    setShowCalculatorModal(false);
  };
  const handleOnBuyCurrency = () => {
    handleOnShowCalculatorModal();
  };

  return (
    <>
      {isShowCalculatorModal && !isEmpty(orderEdit) && (
        <CalculatorModal
          isOpen={isShowCalculatorModal && !isEmpty(orderEdit)}
          onClose={handleOnCloseCalculatorModal}
          orderEdit={orderEdit}
        />
      )}
      <ItemWrap onClick={handleOnBuyCurrency}>
        <CurrencyCode>
          <FlagIcon src={CURRENCY_FLAG_REFERENCES[currency]} />
          <div>
            <span>{currency}</span>
            {CURRENCY_NAME_REFERENCE[currency]}
          </div>
        </CurrencyCode>
        <Rate>{format.toAmountStr2(rate.toFixed(4))}</Rate>
      </ItemWrap>
    </>
  );
};

const ItemWrap = styled.div`
  padding: 18px 8px 20px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  gap: 12px;
  width: 100%;

  background: transparent;
  color: var(--ds-c-black);
  border-bottom: 1px solid var(--ds-c-blue-remox-light);
  cursor: pointer;
  padding: 13px 24px;

  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  text-transform: uppercase;

  span {
    font-weight: 700;
    font-size: 16px;
    color: var(--ds-c-blue);
    display: inline-block;
  }
`;

const CurrencyCode = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin: 0;
  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

const FlagIcon = styled.img`
  width: 30px;
  height: 30px;
  object-fit: cover;
  border: 1px solid var(--ds-c-blue-remox-light);
  border-radius: 50%;
`;

const Rate = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  margin: 0;
`;

export default FXRateItem;
